/* The two public routes. Tokens are 43 URL-safe characters on the real backend; anything that looks like a token is asked for, and the
   server answers one neutral 404 for everything else (mistyped, revoked, expired, draft), so the page never guesses. */
export type ClientRoute = { kind: 'quote' | 'invoice' | 'form'; token: string };

export function parseClientRoute(pathname: string): ClientRoute | null {
  const m = pathname.match(/^\/(q|i|request)\/([^/]+)\/?$/);
  if (!m) return null;
  let token = m[2];
  try {
    token = decodeURIComponent(token);
  } catch {
    return null;
  }
  // the request form's key is not a secret (it only says which business a request is for); the field is still called `token` here
  return { kind: m[1] === 'q' ? 'quote' : m[1] === 'i' ? 'invoice' : 'form', token };
}

export const isClientPagePath = (pathname: string): boolean => /^\/(q|i|request)\/[^/]+\/?$/.test(pathname);
